<div class="p-6 w-full">
  <!-- Row 1: Most Recent Usage and Most Recent Users -->
  <div class="flex flex-col lg:flex-row gap-12 w-full max-w-full lg:max-w-[1000px]">
    <!-- Most Recent Usage Table -->
    <div class="flex-1 min-w-0 flex flex-col lg:w-auto w-full">
      <lib-cdw-divider thickness="2px"></lib-cdw-divider>
      <span class="section-title mt-2">Most Recent Usage</span>
      <lib-cdw-table
        [columns]="recentUsageColumns"
        [data]="recentUsageData"
        [headerBgColor]="gray50"
        styleClass="cdw-table-default"
      ></lib-cdw-table>
    </div>

    <!-- Most Recent Users Table -->
    <div class="flex-1 min-w-0 flex flex-col lg:w-auto w-full">
      <lib-cdw-divider thickness="2px"></lib-cdw-divider>
      <span class="section-title mt-2">Most Recent Users</span>
      <lib-cdw-table
        [columns]="recentUsersColumns"
        [data]="recentUsersData"
        [headerBgColor]="gray50"
        styleClass="cdw-table-default"
      ></lib-cdw-table>
    </div>
  </div>

  <!-- Row 2: Device Enrollment Information -->
     <div class="flex flex-col lg:flex-row gap-12 w-full max-w-full lg:max-w-[1000px]">
  <div class="w-full lg:w-[48%] mt-6">
    <lib-cdw-divider thickness="2px"></lib-cdw-divider>
    <span class="section-title mt-2">Device enrollment information</span>
    <div class="info-grid space-y-5">
      <div class="info-item flex flex-col gap-1">
        <span class="section-subtitle">First enrollment time</span>
        <span class="section-content">{{ firstEnrollmentTime ? (firstEnrollmentTime | timezoneDateTime:(dateTimeSettings$ | async)!) : 'N/A' }}</span>
      </div>
      <div class="info-item flex flex-col gap-1">
        <span class="section-subtitle">Last enrollment time</span>
        <span class="section-content">{{ lastEnrollmentTime ? (lastEnrollmentTime | timezoneDateTime:(dateTimeSettings$ | async)!) : 'N/A' }}</span>
      </div>
    </div>
  </div>
  </div>
</div>
